module.exports = __webpack_public_path__ + "static/fonts/Fredoka-Medium.d57371b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fredoka/Fredoka-Medium.ttf
// module id = 191
// module chunks = 23